








import { defineComponent, onBeforeUnmount, onMounted, reactive, Ref, ref } from '@vue/composition-api';

export default defineComponent({
	setup() {
		const breadcrumb: Ref<HTMLElement | null> = ref(null);
		const breadcrumbState = reactive<{ size: string; itemWidths: number[] }>({ size: '', itemWidths: [] });
		const sizes = {
			short: 'olb-breadcrumb--short',
			shorter: 'olb-breadcrumb--shorter',
			expanded: 'olb-breadcrumb--expanded-short',
		};
		function getBreadcrumbWidths() {
			breadcrumb.value?.querySelectorAll('.olb-breadcrumb__list-item').forEach((item) => {
				breadcrumbState.itemWidths.push(item.clientWidth);
			});
		}
		function handleResize() {
			if (window.innerWidth > breadcrumbState.itemWidths.reduce((partialSum, a) => partialSum + a, 0) + 200) {
				breadcrumbState.size = '';
				return;
			}

			if (
				window.innerWidth >
				breadcrumbState.itemWidths.reduce((partialSum, a) => partialSum + a, 0) -
					breadcrumbState.itemWidths[1] +
					32 +
					200
			) {
				breadcrumbState.size = sizes.short;
				return;
			}
			breadcrumbState.size = sizes.shorter;
		}
		function handleExpand(e: Event) {
			if (breadcrumbState.size === sizes.short || breadcrumbState.size === sizes.shorter) {
				e.preventDefault();
				breadcrumbState.size = sizes.expanded;
			}
		}
		onMounted(() => {
			getBreadcrumbWidths();
			handleResize();
			window.addEventListener('resize', handleResize);
			breadcrumb.value?.addEventListener('click', handleExpand);
		});
		onBeforeUnmount(() => {
			window.removeEventListener('resize', handleResize);
			breadcrumb.value?.removeEventListener('click', handleExpand);
		});
		return { breadcrumbState, breadcrumb };
	},
});
